/*
* @Author: babysoft08
* @Date:   2025-05-30 17:39:26
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-09-19 13:14:55
*/
import axios from 'axios';
import {REP_API_URL} from '../utils/constants.js';

class NetPriceReportServices {
	async getCustomerMultipliers(data){
		const url = `${REP_API_URL}get-customer-multiplier-data`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async exportNetpricePdf(company_name) {
		const url = `${REP_API_URL}export-netprice-pdf/${company_name}/`;
		const headers = {
			'Content-Type': 'application/json',
		};
	
		return axios({
			url: url,
			method: 'get',
			responseType: 'blob',
			headers: headers,
		})
		.then(function (response) {
			return response;
		})
		.catch(function (error) {
			return error.response ? error.response.data : { error: 'Unknown error' };
		});
	}

	async exportNetpriceExcel(company_name) {
		const url = `${REP_API_URL}export-netprice-excel/${company_name}/`;
		const headers = {
			'Content-Type': 'application/json',
		};
	
		return axios({
			url: url,
			method: 'get',
			responseType: 'blob',
			headers: headers,
		})
		.then(function (response) {
			return response;
		})
		.catch(function (error) {
			return error.response ? error.response.data : { error: 'Unknown error' };
		});
	}

	async shareNetprice(data) {
		const url = `${REP_API_URL}share-netprice/`;
		const headers = {
			'Content-Type': 'application/json',
		};
	
		return axios({
			url: url,
			method: 'post',
			data: data,
			headers: headers,
		})
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			return error.response ? error.response.data : { error: 'Unknown error' };
		});
	}
}
export default NetPriceReportServices;